export const UsageType = {
    DATA_EXTRACTION: 'DATA_EXTRACTION',
    STORAGE: 'STORAGE',
    TRANSACTION: 'TRANSACTION',
    EMAIL: 'EMAIL',
    WHATSAPP: 'WHATSAPP',
    USER: 'USER',
    FLOW: 'FLOW',
};
